const get = require('lodash/get')
const { listProductsForPrograms } = require('./list-for-programs-services')
const {
  buildServiceColumns,
  buildWarehouseServiceColumns,
  injectWarehouseColumns,
  getServiceIdsFromConfigurationDocs
} = require('./../../tools')
const utils = require('./../../utils')

exports.exportProducts = async (state, opts = {}) => {
  const userPrograms = get(state, 'user.programs', [])
  const products = await listProductsForPrograms(state, userPrograms)
  const serviceConfigurations = await getServiceConfigurationsForPrograms(state, userPrograms)
  const serviceIds = getServiceIdsFromConfigurationDocs(serviceConfigurations)
  const serviceColumns = buildServiceColumns(serviceIds)
  const warehouseColumns = buildWarehouseServiceColumns(serviceConfigurations)
  const additionalColumns = Object.assign(
    {},
    get(opts, 'additionalColumns', {}),
    injectWarehouseColumns(serviceColumns, warehouseColumns)
  )
  return utils.sheet.encode(products, Object.assign({}, opts, { additionalColumns }))
}

async function getServiceConfigurationsForPrograms (state, programIds) {
  const serviceConfigurationsByProgram = await Promise.all(
    (programIds || []).map(programId => state.dal.product.getProgramConfiguration(state, programId))
  )
  return serviceConfigurationsByProgram.reduce((acc, docs) => acc.concat(docs), [])
}

exports.getServiceConfigurationsForPrograms = getServiceConfigurationsForPrograms
